import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './utilities.css';
import './styles/centeredSlider.css';
import './styles/table.css';

import App from './App';

// SWIPER CSS
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";

// RESPONSIVE TABLE
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

// REACT DATEPICKER
import "react-datepicker/dist/react-datepicker.css";

import { Provider } from 'react-redux';
import store from 'redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);